<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <div class="d-flex align-items-center justify-content-between flex-wrap pb-3" style="gap: 8px; border-bottom: 1px solid #c8ced3;">
                    <h5 class="mb-0 pb-0" style="border-bottom: none;">Detail Persiapan Lelang</h5>
                    <b-button v-if="panduanUrl" size="sm" variant="outline-primary" name="panduanBtn" :href="panduanUrl" target="_blank" rel="noopener noreferrer">
                        <i class="fa fa-question-circle mr-1"></i>Panduan
                    </b-button>
                </div>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA LELANG</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Order</b-col>
                    <b-col>
                        {{$helper.changeDateFormat(dataLelang.tanggalOrder)}}
                        {{$helper.changeDateFormatGetHour(dataLelang.tanggalOrder)}}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Mulai Packing</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataLelang.tanggalKirim) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Deadline Penyelesaian Packing dan Pengiriman Drop Off</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataLelang.tanggalDropOff) }}<span v-if="dataLelang.tanggalDropOff"> 21.05 WIB</span></b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Mulai Penjemputan Lelang</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataLelang.tanggalPengirimanBox) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jumlah Unit</b-col>
                    <b-col>{{ dataLelang.jumlahUnit }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jumlah Hilang</b-col>
                    <b-col>{{ dataLelang.jumlahHilang }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Sudah Masuk {{ dusWord }}</b-col>
                    <b-col>{{ dataLelang.jumlahSudahPacking }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Belum Masuk {{ dusWord }}</b-col>
                    <b-col>{{ dataLelang.jumlahBelumPacking }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col>{{ dataLelang.status }}</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA BARANG</h6>
                <b-row class="mb-3">
                    <b-col md="6">
                        <b-form-group label="No. Faktur" label-for="filterInput">
                            <b-form-input
                                v-model="input.filterNoFaktur" name="filterNoFaktur"
                                id="filterInput"
                                type="search"
                                placeholder="Masukkan no. faktur"
                                @keyup.enter="onFilter"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group :label="noDusLabel" label-for="filterBoxNumber">
                            <multiselect id="filterBoxNumber" name="filterBoxNumber"
                                :value="boxNumberOptions.find(item => item.id == input.filterBoxNumber) || null"
                                :options="boxNumberOptions" :internal-search="true" :allow-empty="true"
                                deselect-label="" select-label="" label="name" track-by="id"
                                :placeholder="noDusLabel"
                                @input="input.filterBoxNumber = $event ? $event.id : null" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Jenis Barang" label-for="filterJenisBarang">
                            <multiselect id="filterJenisBarang" name="jenisBarang"
                                :value="optionJenisBarang.find(item => item.id == input.filterJenisBarang) || null"
                                :options="optionJenisBarang" :internal-search="true" :allow-empty="true"
                                deselect-label="" select-label="" label="name" track-by="id"
                                placeholder="Jenis Barang"
                                @input="input.filterJenisBarang = $event ? $event.id : null" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Status" label-for="filterStatus">
                            <b-form-select id="filterStatus" v-model="input.filterStatus" name="status" :options="statusOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Packing" label-for="filterPacking">
                            <b-form-select id="filterPacking" v-model="input.filterPacking" name="filterPacking" :options="packingOptions" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Packing</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <div>
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter">
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
                <b-table bordered hover show-empty
                    :busy="isBusy" 
                    :items="dataPersiapanLelangItems" 
                    :fields="itemFields"
                    :no-local-sorting="false"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data barang untuk dicek.
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="warning" v-if="row.item.status == 'PACKING'">PACKING</b-badge>
                        <b-badge variant="danger" v-else-if="row.item.status == 'HILANG'">HILANG</b-badge>
                        <b-badge variant="dark" v-else-if="row.item.status == 'PENGIRIMAN'">PENGIRIMAN</b-badge>
                        <b-badge variant="success" v-else-if="row.item.status == 'DITERIMA'">DITERIMA</b-badge>
                        <b-badge variant="warning" v-else-if="row.item.status == 'KIRIM BALIK'">KIRIM BALIK</b-badge>
                        <b-badge variant="primary" v-else>TERJUAL</b-badge>
                    </template>
                    <template v-slot:head(status)>
                        Status 
                        <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                    </template>
                    <template v-slot:cell(barang)="row">
                        <p class="mb-0">{{ row.item.jenis.name }}</p>
                        <p class="mb-0 smallText text-muted">
                            {{ row.item.merk.name }} - {{ row.item.tipe.name }}
                        </p>
                        <p class="mb-0 smallText text-muted">{{ row.item.imeiSn }}</p>
                    </template>
                    <template v-slot:cell(hargaBarang)="row">
                        <div class="text-right no-wrap" v-if="row.item.hargaBarang !== null">Rp. {{$helper.addThousandSeparator(row.item.hargaBarang)}} </div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.hargaBarang)}} </div>
                    </template>
                    <template v-slot:cell(noDus)="row">
                        <span v-if="row.item.noDus">{{ $helper.dusNumber(row.item.noDus) }}</span>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:cell(aksi)="row">
                        <b-button variant="pgiBtn" size="sm" name="printBarcode" @click="printBarcode(row.item.gadaiId)" v-if="IS_HAVE_PERMISSION_BARCODE">
                            <i class="fa fa-print"></i>
                        </b-button>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </div>
        </b-card>
        <b-card v-if="initStatus == 1" class="mt-4">
            <template v-slot:header>
                <h5 class="mb-0">Barang Keluar Lelangan</h5>
            </template>
            <b-table bordered hover show-empty responsive class="mb-0"
                :busy="isLoadingTakenOutItems"
                :items="takenOutItems"
                :fields="takenOutItemFields">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada barang yang keluar lelangan.
                </template>
                <template v-slot:cell(barang)="row">
                    <p class="mb-0">{{ row.item.jenis }}</p>
                    <p class="mb-0 smallText text-muted">{{ row.item.merk }} - {{ row.item.tipe }}</p>
                    <p class="mb-0 smallText text-muted" v-if="row.item.imeiSn">{{ row.item.imeiSn }}</p>
                </template>
                <template v-slot:cell(lastBoxNumber)="row">
                    <span v-if="row.item.lastBoxNumber != null">{{ $helper.dusNumber(row.item.lastBoxNumber) }}</span>
                    <span v-else class="text-muted">-</span>
                </template>
                <template v-slot:cell(takenOutAt)="row">
                    {{ $helper.formatDateAndHour(row.item.takenOutAt) }}
                </template>
                <template v-slot:cell(isRestored)="row">
                    <b-badge variant="success" v-if="row.item.isRestored">Masuk Kembali Lelangan</b-badge>
                    <b-badge variant="warning" v-else>Keluar Lelangan</b-badge>
                </template>
            </b-table>
        </b-card>
        <b-card v-if="initStatus == 1" class="mt-4">
            <template v-slot:header>
                <h5 class="mb-0">Daftar {{ dusWord }}</h5>
            </template>
            <div class="mb-3 d-flex align-items-center flex-wrap" style="gap: 8px;">
                <b-badge class="shipment-status-badge" :variant="shipmentStatusBadge.variant">{{ shipmentStatusBadge.text }}</b-badge>
                <b-button v-if="rejectInfo" variant="link" size="sm" class="p-0" @click="$bvModal.show('modal-alasan-tolak-dus')">
                    Lihat Alasan
                </b-button>
                <b-badge v-if="limitGoldValuePerBox != null" variant="dark" class="shipment-status-badge">
                    Limit per {{ dusWord }}: Rp. {{ $helper.addThousandSeparator(limitGoldValuePerBox) }}
                </b-badge>
            </div>
            <div v-if="dropOffCabangName" class="dropoff-info mb-3">
                <div class="dropoff-info-icon"><i class="fa fa-map-marker"></i></div>
                <div class="flex-grow-1">
                    <div class="smallText text-muted">Titik Drop Off</div>
                    <strong>{{ dropOffCabangName }}</strong>
                    <div class="smallText text-muted">{{ dropOffCabangAlamat || 'Alamat belum tersedia' }}</div>
                </div>
                <b-button v-if="dropOffCabangMapsUrl" :href="dropOffCabangMapsUrl" target="_blank" rel="noopener" size="sm" variant="outline-primary" class="text-nowrap">
                    <i class="fa fa-external-link mr-1"></i>Buka Maps
                </b-button>
            </div>
            <b-alert :show="overGoldLimitDusNumbers.length > 0" variant="danger">
                {{ dusWord.charAt(0) + dusWord.slice(1).toLowerCase() }} nomor {{ overGoldLimitDusNumbers.join(', ') }} melebihi batas total nominal pinjaman emas Rp. {{ $helper.addThousandSeparator(limitGoldValuePerBox) }} dengan lebih dari 1 barang. Semua {{ dusWord.toLowerCase() }} tidak bisa dikirim menggunakan metode pengiriman Paxel.
            </b-alert>
            <div class="detail-data-wrapper mb-4">
                <div v-if="dusList.length == 0" class="text-muted text-center py-3">
                    Belum ada {{ dusWord }}. Klik "Tambah {{ dusWord }} Baru" untuk mulai.
                </div>
                <div v-else class="dus-card-list">
                    <div v-for="dus in dusList" :key="dus.id" class="dus-card mb-2">
                        <div class="dus-card-title">
                            <strong>{{ dus.dusType }} #{{ dus.dusNumber }}</strong>
                            <b-badge variant="secondary" v-if="!dus.isOpen && canKirimDus">Ditutup</b-badge>
                            <b-badge variant="info" class="text-white" v-else-if="canKirimDus">Terbuka</b-badge>
                        </div>
                        <div class="smallText text-muted mt-1">{{ dus.rincianBarang || '-' }} (Total: {{ dus.jumlahBarang }} barang)</div>
                        <div class="mt-3">
                            <b-button variant="pgiBtn" size="sm" class="mr-2 mb-2" @click="goToDusDetail(dus)">
                                <i class="fa fa-folder-open mr-1"></i>Detail
                            </b-button>
                            <b-button v-if="canTutupDus(dus)" variant="secondary" size="sm" class="mr-2 mb-2" @click="openModalTutupDus(dus)">
                                <i class="fa fa-lock mr-1"></i>Tutup {{ dusWord }}
                            </b-button>
                            <b-button v-if="canBukaKembaliDus(dus)" variant="info" size="sm" class="mr-2 mb-2 text-white" @click="openModalBukaKembaliDus(dus)">
                                <i class="fa fa-unlock mr-1"></i>Buka Kembali
                            </b-button>
                            <b-button v-if="canHapusDus(dus)" variant="outline-danger" size="sm" class="mb-2" @click="openModalHapusDus(dus)">
                                <i class="fa fa-trash mr-1"></i>Hapus {{ dusWord }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-wrapper-btn">
                <b-button class="mr-2 mb-2" name="tambahDusBtn" variant="pgiBtn" :disabled="isLoadingDusTypeOptions" @click="openModalTambahDus" v-if="canTambahDusBaru">
                    <b-spinner small v-if="isLoadingDusTypeOptions" />
                    <span v-else><i class="fa fa-cube mr-2"></i>Tambah {{ dusWord }} Baru</span>
                </b-button>
                <ModalFotoPengiriman v-if="shipmentPhotoGroups.length > 0" buttonClass="mr-2 mb-2" :groups="shipmentPhotoGroups" />
                <b-button class="mr-2 mb-2" name="lihatRangkumanDusBtn" variant="pgiBtn" :disabled="isLoadingBoxesSummary" @click="openModalRangkumanDus">
                    <b-spinner small v-if="isLoadingBoxesSummary" />
                    <span v-else><i class="fa fa-list mr-2"></i>Lihat Rangkuman {{ dusWord }}</span>
                </b-button>
                <b-button class="mr-2 mb-2" name="kirimDusBtn" variant="dark" :disabled="pendingDuses.length == 0 || isLoadingKirimOptions" @click="openModalKirim" v-if="canKirimSemuaDus">
                    <b-spinner small v-if="isLoadingKirimOptions" />
                    <span v-else><i class="fa fa-send mr-2"></i>Kirim Semua {{ dusWord }} ({{ pendingDuses.length }})</span>
                </b-button>
            </div>
            <div class="form-wrapper-btn mt-0" v-if="canResetShipment">
                <b-button class="mb-2" name="resetDropOffBtn" variant="danger" :disabled="isResettingShipment" @click="$bvModal.show('modal-confirm-reset-dropoff')">
                    <i class="fa fa-undo mr-2"></i>Reset Pengiriman
                </b-button>
            </div>
        </b-card>
        <b-card v-if="initStatus == 1" class="mt-4">
            <template v-slot:header>
                <h5 class="mb-0">Cetak Dokumen</h5>
            </template>
            <b-row>
                <b-col md="4" class="mb-3">
                    <div class="print-card">
                        <div class="print-card-icon"><i class="fa fa-file-text-o"></i></div>
                        <strong>Tanda Terima</strong>
                        <div class="smallText text-muted">Bukti serah terima seluruh barang lelang dalam batch ini.</div>
                        <div class="print-card-actions">
                            <b-button size="sm" name="cetakTandaTerimaBtn" variant="pgiBtn" @click="openModalCetak">
                                <i class="fa fa-print mr-1"></i>Cetak
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="4" class="mb-3" v-if="canManagePacking">
                    <div class="print-card">
                        <div class="print-card-icon"><i class="fa fa-certificate"></i></div>
                        <strong>Segel Lelang</strong>
                        <div class="smallText text-muted">Segel untuk setiap {{ dusWord.toLowerCase() }} sebelum dikirim.</div>
                        <div class="smallText text-danger mt-1" v-if="dusList.length == 0">Belum ada {{ dusWord.toLowerCase() }}.</div>
                        <div class="print-card-actions">
                            <b-button size="sm" name="cetakSegelLelangBtn" variant="pgiBtn" :disabled="isPrintingSegel || dusList.length == 0" @click="printSegelLelang(false)">
                                <b-spinner small v-if="isPrintingSegel && !isPrintingSegelWithGold" />
                                <span v-else><i class="fa fa-print mr-1"></i>Cetak</span>
                            </b-button>
                            <b-button size="sm" name="cetakSegelGmBtn" variant="outline-primary" :disabled="isPrintingSegel || dusList.length == 0" @click="printSegelLelang(true)" v-if="isElektronik">
                                <b-spinner small v-if="isPrintingSegel && isPrintingSegelWithGold" />
                                <span v-else><i class="fa fa-print mr-1"></i>Cetak + GM</span>
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="4" class="mb-3" v-if="canManagePacking">
                    <div class="print-card">
                        <div class="print-card-icon"><i class="fa fa-tag"></i></div>
                        <strong>Label Lelang</strong>
                        <div class="smallText text-muted">Label penanda untuk setiap {{ dusWord.toLowerCase() }}.</div>
                        <div class="smallText text-danger mt-1" v-if="dusList.length == 0">Belum ada {{ dusWord.toLowerCase() }}.</div>
                        <div class="print-card-actions">
                            <b-button size="sm" name="cetakLabelLelangBtn" variant="pgiBtn" :disabled="isPrintingLabel || dusList.length == 0" @click="printLabelLelang(false)">
                                <b-spinner small v-if="isPrintingLabel && !isPrintingLabelWithGold" />
                                <span v-else><i class="fa fa-print mr-1"></i>Cetak</span>
                            </b-button>
                            <b-button size="sm" name="cetakLabelGmBtn" variant="outline-primary" :disabled="isPrintingLabel || dusList.length == 0" @click="printLabelLelang(true)" v-if="isElektronik">
                                <b-spinner small v-if="isPrintingLabel && isPrintingLabelWithGold" />
                                <span v-else><i class="fa fa-print mr-1"></i>Cetak + GM</span>
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <!-- <ModalConfirm id="modal-confirm-kirim" title="Confirm Kirim ke Pelelangan" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengirim Order Lelang ini ke Pelelangan?" @submit="onSubmit" /> -->
        <ModalConfirm id="modal-confirm-cetak" title="Confirm Cetak Tanda Terima" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mencetak tanda terima lelang?" @submit="onSubmitCetak" />
        <ModalConfirm id="modal-confirm-hapus-dus" :title="`Hapus ${dusWord}`" :isSubmitting="isDeletingDus" :desc="`Apakah anda yakin ingin menghapus ${dusWord.toLowerCase()} ini?`" @submit="onDeleteDus" />
        <ModalConfirm id="modal-confirm-tutup-dus" :title="`Tutup ${dusWord}`" :isSubmitting="isClosingDus" :desc="`Apakah anda yakin ingin menutup ${dusWord.toLowerCase()} ini? Barang tidak bisa ditambah lagi selama masih tertutup.`" @submit="onCloseDus" />
        <ModalConfirm id="modal-confirm-buka-kembali-dus" :title="`Buka Kembali ${dusWord}`" :isSubmitting="isReopeningDus" :desc="`Apakah anda yakin ingin membuka kembali ${dusWord.toLowerCase()} ini?`" @submit="onReopenDus" />
        <ModalConfirm id="modal-confirm-reset-dropoff" title="Reset Pengiriman" :isSubmitting="isResettingShipment" desc="Aksi ini akan memperbolehkan cabang untuk mengunggah ulang foto/video, atau menggunakan foto/video sebelumnya." @submit="onResetShipment" />
        <b-modal id="modal-alasan-tolak-dus" title="Alasan Penolakan" centered hide-footer>
            <div v-if="rejectInfo">
                <div class="detail-data-wrapper mb-3">
                    <h6 class="form-title mb-1">Alasan</h6>
                    <p class="mb-0" style="word-break: break-word;">{{ rejectInfo.note }}</p>
                </div>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Ditolak Oleh</b-col>
                    <b-col>{{ rejectInfo.rejectedBy ? rejectInfo.rejectedBy.name : '-' }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Cabang Drop Off</b-col>
                    <b-col>{{ rejectInfo.dropOffCabang ? rejectInfo.dropOffCabang.name : '-' }}</b-col>
                </b-row>
                <b-row>
                    <b-col cols="5" class="detail-data-label">Waktu Ditolak</b-col>
                    <b-col>
                        {{ $helper.changeDateFormat(rejectInfo.rejectedAt) }}
                        {{ $helper.changeDateFormatGetHour(rejectInfo.rejectedAt) }}
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        <b-modal id="modal-rangkuman-dus" :title="`Rangkuman ${dusWord}`" centered hide-footer size="lg">
            <b-table bordered hover show-empty responsive :items="boxesSummary" :fields="rangkumanDusFields">
                <template v-slot:empty>
                    Belum ada {{ dusWord }}.
                </template>
                <template v-slot:cell(beratKeringEmasAwal)="row">
                    <div class="text-right" v-if="row.item.beratKeringEmasAwal != null">{{ row.item.beratKeringEmasAwal }}</div>
                </template>
                <template v-slot:cell(beratKeringEmas)="row">
                    <div class="text-right" v-if="row.item.beratKeringEmas != null">{{ row.item.beratKeringEmas }}</div>
                </template>
                <template v-slot:cell(nilaiPinjamanAwal)="row">
                    <div class="text-right" v-if="row.item.nilaiPinjamanAwal != null">Rp. {{ $helper.addThousandSeparator(row.item.nilaiPinjamanAwal) }}</div>
                </template>
            </b-table>
        </b-modal>
        <b-modal id="modal-download-segelLelang" title="Cetak Segel Lelang" size="xl" ok-only centered no-close-on-backdrop no-close-on-esc>
            <div v-if="isPrintingSegel" class="d-flex justify-content-center">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div v-else>
                <b-alert show variant="warning">
                    Klik <strong>nama cabang</strong> pada lembar segel untuk mencetak.
                </b-alert>
                <div class="segel-scroll">
                    <iframe class="segel-frame" height="500" :src="segelPathDownload" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </b-modal>
        <b-modal id="modal-download-labelLelang" title="Cetak Label Lelang" size="xl" ok-only centered no-close-on-backdrop no-close-on-esc>
            <div v-if="isPrintingLabel" class="d-flex justify-content-center">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div v-else>
                <b-alert show variant="warning">
                    Klik <strong>nama cabang</strong> pada lembar label untuk mencetak.
                </b-alert>
                <div class="segel-scroll">
                    <iframe class="segel-frame" height="500" :src="labelPathDownload" frameborder="0" allowfullscreen></iframe>
                </div>
            </div>
        </b-modal>
        <b-modal id="modal-download-tandaTerima" centered title="Download Tanda Terima" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadLink == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Sukses, silahkan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" target="_blank">
                        <i class="fa fa-download mr-2"></i>
                        Download Tanda Terima
                    </a>
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PACKING</h6>
                <p class="smallText mb-0">Barang ini masih dalam persiapan untuk dilelangkan. Posisi barang masih di cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">HILANG</h6>
                <p class="smallText mb-0">Barang dinyatakan hilang / tidak ditemukan oleh pihak pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">PENGIRIMAN</h6>
                <p class="smallText mb-0">Barang dalam pengiriman menuju pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Barang sudah diterima oleh pihak pelelangan.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">KIRIM BALIK</h6>
                <p class="smallText mb-0">Barang dalam pengiriman kembali dari pelelangan ke cabang.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">TERJUAL</h6>
                <p class="smallText mb-0">Barang sudah terjual.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="m-print-barcode" title="Print Ulang Barcode" size="xl" ok-only centered no-close-on-backdrop no-close-on-esc>
            <div v-if="isLoadingBarcode" class="d-flex justify-content-center">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <div v-else>
                <p class="smallText text-muted">
                    Bila tombol print / cetak tidak ditemukan, anda dapat melakukan pencetakan dengan cara klik kanan pada lembar yang akan dicetak, lalu pilih Print.
                </p>
                <b-row>
                    <b-col><iframe width="100%" height="300" :src="barcodePath" frameborder="0" allowfullscreen></iframe></b-col>
                </b-row>
            </div>
        </b-modal>

        <ModalKirimDus :id="id" :dusWord="dusWord" :pendingDuses="pendingDuses" :kirimInfo="kirimInfo" :shipmentStatus="shipmentStatus" :shipmentPhotoGroups="shipmentPhotoGroups" :jenisPinjamanId="jenisPinjaman ? jenisPinjaman.id : null" @submitted="onKirimSubmitted" />

        <b-modal id="modal-tambah-dus" :title="`Tambah ${dusWord} Baru`" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group :label="isFoodContainer ? `Pilih ${dusWord}` : 'Pilih Ukuran Dus'">
                <multiselect
                    name="dusTypePicker"
                    v-model="newDusType"
                    :options="dusTypeOptions"
                    :internal-search="true"
                    :allow-empty="false"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    :placeholder="`-- Pilih ukuran ${dusWord.toLowerCase()} --`"
                />
            </b-form-group>
            <div class="form-wrapper-btn text-right">
                <b-button variant="pgiBtn" :disabled="!newDusType || isCreatingDus" @click="confirmTambahDus">
                    <b-spinner small v-if="isCreatingDus" />
                    <span v-else><i class="fa fa-plus mr-2"></i>Tambah {{ dusWord }}</span>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ModalKirimDus from './ModalKirimDus'
import ModalFotoPengiriman from './ModalFotoPengiriman'
import CONSTANTS from '@/constants'

export default {
    name: 'detail-persiapan-lelang',
    components: {
        ModalKirimDus,
        ModalFotoPengiriman,
    },
    data(){
        return{
            id: null,
            panduanUrl: null,
            isBusy: true,
            initStatus: 1,
            isSubmitting: false,
            input:{
                show: 10,
                filterNoFaktur: null,
                filterJenisBarang: null,
                filterStatus: null,
                filterPacking: null,
                filterBoxNumber: null,
                // filterHilangOnly: false,
                // sortBy: null,
                // sortDesc: null
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur" },
                { key: "noDus", label: "No. Dus" },
                { key: "barang", label: "Barang" },
                { key: "hargaBarang", label: "Harga Barang" },
                { key: "status", label: "Status" },
                { key: "aksi", label: "Aksi" },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataLelang: {},
            dataPersiapanLelangItems:[],
            optionJenisBarang: [],
            statusOption: [
                { id: 0, name: 'Order' },
                { id: 1, name: 'Hilang' },
                { id: 2, name: 'Pengiriman' },
                { id: 3, name: 'Diterima' },
                { id: 4, name: 'Kirim Balik' },
                { id: 5, name: 'Terjual' }
            ],
            packingOption: [
                { id: 1, name: 'Sudah Masuk Dus' },
                { id: 0, name: 'Belum Masuk Dus' },
            ],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            query: "",
            isLoadLink: false,
            filePathDownload: "",
            isPrintingSegel: false,
            isPrintingSegelWithGold: false,
            isPrintingLabelWithGold: false,
            segelPathDownload: "",
            isPrintingLabel: false,
            labelPathDownload: "",
            barcodePath: "",
            isLoadingBarcode: false,
            selectedId: null,

            dusList: [],
            takenOutItems: [],
            isLoadingTakenOutItems: false,
            dusTypeOptions: [
            ],
            newDusType: null,
            isCreatingDus: false,
            isLoadingDusTypeOptions: false,
            activeDus: null,
            isDeletingDus: false,
            isClosingDus: false,
            isReopeningDus: false,
            isResettingShipment: false,
            kirimInfo: null,
            isLoadingKirimOptions: false,
            shipmentStatus: null,
            limitGoldValuePerBox: null,
            jenisPinjaman: null,
            dropOffCabangName: null,
            dropOffCabangAlamat: null,
            dropOffCabangLinkMaps: null,
            shipmentPhotoPaths: [],
            shipmentPhotos: [],
            rejectInfo: null,
            boxesSummary: [],
            isLoadingBoxesSummary: false,
            rangkumanDusBaseFields: [
                { key: "noDus", label: "Nomor Dus" },
                { key: "tipeDus", label: "Tipe Dus" },
                { key: "jumlahBarang", label: "Jumlah Barang" },
                { key: "beratKeringEmasAwal", label: "Berat Kering Emas Awal (gr)" },
                { key: "beratKeringEmas", label: "Berat Kering Emas Input (gr)" },
                { key: "nilaiPinjamanAwal", label: "Nilai Pinjaman Awal" },
            ],
        }
    },
    computed: {
        overGoldLimitDusNumbers() {
            if (!this.isFoodContainer || this.limitGoldValuePerBox == null) return []
            return this.dusList
                .filter(dus => dus.jumlahBarang > 1 && dus.totalValue > this.limitGoldValuePerBox)
                .map(dus => dus.dusNumber)
        },
        IS_HAVE_PERMISSION_BARCODE() {
            return this.$helper.hasPermissionMenuChildren('GPB')
        },
        rangkumanDusFields() {
            if (this.isElektronik) {
                return this.rangkumanDusLabeledFields.filter(field => !['beratKeringEmasAwal', 'beratKeringEmas', 'nilaiPinjamanAwal'].includes(field.key))
            }
            return this.rangkumanDusLabeledFields
        },
        dusWord() {
            return this.isFoodContainer ? 'Food Container' : 'Dus'
        },
        noDusLabel() {
            return this.isFoodContainer ? 'No. FC' : 'No. Dus'
        },
        boxNumberOptions() {
            return this.dusList.map(dus => ({
                id: dus.dusNumber,
                name: `${dus.dusType} #${dus.dusNumber}`,
            }))
        },
        takenOutItemFields() {
            return [
                { key: "noFaktur", label: "No. Faktur" },
                { key: "barang", label: "Barang" },
                { key: "lastBoxNumber", label: `No. ${this.dusWord} Terakhir` },
                { key: "takenOutAt", label: "Waktu Keluar" },
                { key: "isRestored", label: "Status" },
            ]
        },
        isFoodContainer() {
            return this.jenisPinjaman != null && this.jenisPinjaman.id == CONSTANTS.GADAI.JENIS.EMAS
        },
        isElektronik() {
            return this.jenisPinjaman != null && this.jenisPinjaman.id == CONSTANTS.GADAI.JENIS.ELEKTRONIK
        },
        itemFields() {
            if (!this.isFoodContainer) return this.fields
            return this.fields.map(field => field.key == 'noDus' ? { ...field, label: 'No. FC' } : field)
        },
        packingOptions() {
            return this.packingOption.map(item => ({ ...item, name: item.name.replace('Dus', this.dusWord) }))
        },
        rangkumanDusLabeledFields() {
            return this.rangkumanDusBaseFields.map(field => ({ ...field, label: this.labelDus(field.label) }))
        },
        pendingDuses() {
            return this.dusList
        },
        canKirimDus() {
            const status = CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS
            return [status.PACKING, status.DITOLAK_DROPOFF].includes(this.shipmentStatus)
        },
        canManagePacking() {
            return this.$helper.hasPermissionMenuChildren(CONSTANTS.PERMISSION.LELANG_PACKING)
        },
        canTambahDusBaru() {
            return this.canManagePacking && this.canKirimDus
        },
        canKirimSemuaDus() {
            return this.canManagePacking && this.canKirimDus
        },
        canResetShipment() {
            return this.$helper.hasPermissionMenuChildren(CONSTANTS.PERMISSION.LELANG_PACKING_RESET_CAPABILITIES)
                && [CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.PENGIRIMAN_KE_DROPOFF, CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.SELESAI, CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS.DITERIMA_DROPOFF].includes(this.shipmentStatus)
        },
        shipmentStatusBadge() {
            const status = CONSTANTS.LELANG_PACKING.SHIPMENT_STATUS
            const map = {
                [status.PACKING]: { variant: 'warning', text: 'Packing' },
                [status.SELESAI]: { variant: 'success', text: 'Selesai' },
                [status.PENGIRIMAN_KE_DROPOFF]: { variant: 'dark', text: 'Dalam Pengiriman ke Drop Off' },
                [status.DITERIMA_DROPOFF]: { variant: 'success', text: 'Diterima di Drop Off' },
                [status.DITOLAK_DROPOFF]: { variant: 'danger', text: 'Ditolak oleh Drop Off' },
            }
            return map[this.shipmentStatus] || { variant: 'secondary', text: '-' }
        },
        dropOffCabangMapsUrl() {
            const url = this.dropOffCabangLinkMaps
            return url && /^https?:\/\//i.test(url) ? url : null
        },
        shipmentPhotoGroups() {
            if (this.shipmentPhotos.length == 0) {
                return this.shipmentPhotoPaths.length > 0 ? [{ label: 'Foto/Video', isVideo: false, urls: this.shipmentPhotoPaths.map(path => this.$helper.buildAwsFileUrl(this.$baseFilePathAws, path)) }] : []
            }
            return this.$helper.groupShipmentPhotos(this.$baseFilePathAws, this.shipmentPhotos)
        },
    },
    methods:{

        // "No. Dus" jadi "No." untuk Food Container — namanya kepanjangan buat header tabel
        labelDus(label) {
            return this.isFoodContainer ? label.replace(/ ?Dus/, '').trim() : label
        },

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            // this.initStatus = 0
            this.id = this.$route.params.id

            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)
            this.query = this.query+"&id="+this.id
            
            let getSingleDataPersiapanLelang = this.$axios.get(`lelang-persiapan/${this.id}`).then(response => {
                this.dataLelang = response.data
                this.toggleBusy()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            let getPersiapanLelangItems= this.$axios.get(`lelang-persiapan/${this.id}/items/${this.query}`).then(response => {
                this.dataPersiapanLelangItems = response.data.data
               
                this.updateTotalItem(response.data.total)

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            let getDusList = getPersiapanLelangItems.then(() => this.getDusList())

            this.getTakenOutItems()

            this.$axios.get("lelang-persiapan/video-panduan").then(response => {
                const url = response.data && response.data.videoPanduanUrl
                this.panduanUrl = /^https?:\/\//i.test(url) ? url : null
            })
            .catch(() => {
                this.panduanUrl = null
            })

            let getShipmentStatus = this.getShipmentStatus()

            let getJenisBarang = getShipmentStatus
                .then(() => this.$axios.get(`barang-jenis/${this.isFoodContainer ? 'emas' : 'elektronik'}?showAll=true`))
                .then(response => {
                    this.optionJenisBarang = response.data
                })

            Promise.all([getJenisBarang, getSingleDataPersiapanLelang, getPersiapanLelangItems, getDusList, getShipmentStatus]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Ambil Data Cek Item -----------------

       getPersiapanLelangItems(){
            this.isBusy = true
            this.page = this.currentPage-1
            this.dataPersiapanLelangItems = []
            this.query = this.buildItemsQuery(this.page, this.size)

            this.$axios.get(`lelang-persiapan/${this.id}/items/${this.query}`).then(response => {
                this.dataPersiapanLelangItems = response.data.data
                this.updateTotalItem(response.data.total)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })
        },

        buildItemsQuery(page, size){
            let query = this.$helper.makeQuery(page, size)

            if (this.input.filterNoFaktur != null) query = query + "&filterNoFaktur=" + encodeURIComponent(this.input.filterNoFaktur)
            if (this.input.filterJenisBarang != null) query = query + "&filterJenis=" + encodeURIComponent(this.input.filterJenisBarang)
            if (this.input.filterStatus != null) query = query + "&filterStatus=" + encodeURIComponent(this.input.filterStatus)
            if (this.input.filterPacking != null) query = query + "&filterPackingStatus=" + encodeURIComponent(this.input.filterPacking)
            const boxNumber = this.input.filterBoxNumber
            if (boxNumber != null) query = query + "&filterBoxNumber=" + encodeURIComponent(boxNumber)

            return query
        },

        onSubmitCetak(){
            this.axiosTandaTerima()
        },

        axiosTandaTerima(){
            let payload = new FormData()

            //----------------- Append Data Persiapan Lelang -----------------

            payload.append("id", this.id)

            //----------------- Submit Semua Data -----------------
            this.isLoadLink = true
            this.isSubmitting = true
            this.$axios.get(`lelang-persiapan/cetak/tanda-terima-all/?id=${this.id}`, payload).then(response => {
                this.filePathDownload = response.data
                this.$bvModal.show('modal-download-tandaTerima')
                this.$bvModal.hide('modal-confirm-cetak')
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
                this.isLoadLink = false
            })
		},
		
        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------
        
        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.getPersiapanLelangItems()
        },

        onPageChange(){
            this.getPersiapanLelangItems()
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.input.filterJenisBarang = null
            this.input.filterStatus = null
            this.input.filterPacking = null
            this.input.filterBoxNumber = null
            this.currentPage = 1
            this.getPersiapanLelangItems()
        },

        onFilter(){
            this.currentPage = 1
            this.getPersiapanLelangItems()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Lain -----------------

        // openModalConfirm(){
        //     this.$bvModal.show("modal-confirm-kirim")
        // },

        openModalCetak(){
            this.$bvModal.show("modal-confirm-cetak")
        },

        getDusList(){
            return this.$axios.get(`lelang-packing/${this.id}/boxes`).then(response => {
                this.dusList = response.data.map(dus => ({
                    id: dus.boxId,
                    dusNumber: this.$helper.dusNumber(dus.boxNumber),
                    dusType: dus.boxType.name,
                    boxTypeId: dus.boxType.id,
                    jumlahBarang: dus.items.reduce((total, item) => total + item.count, 0),
                    rincianBarang: dus.items.map(item => `${item.jenisBarang.name} ${item.count}`).join(', '),
                    isOpen: dus.isOpen,
                    totalValue: dus.totalValue,
                }))
            })
            .catch(error => this.$helper.parseError(this, error))
        },

        getTakenOutItems(){
            this.isLoadingTakenOutItems = true
            return this.$axios.get(`lelang-packing/${this.id}/taken-out-items`).then(response => {
                this.takenOutItems = response.data || []
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isLoadingTakenOutItems = false
            })
        },

        getShipmentStatus(){
            return this.$axios.get(`lelang-packing/shipment/${this.id}`).then(response => {
                this.shipmentStatus = response.data.status.id
                this.shipmentPhotoPaths = response.data.photoPaths || []
                this.shipmentPhotos = response.data.photos || []
                this.rejectInfo = response.data.reject || null
                this.dropOffCabangName = response.data.dropOffCabangName || null
                this.dropOffCabangAlamat = response.data.dropOffCabangAlamat || null
                this.dropOffCabangLinkMaps = response.data.dropOffCabangLinkMaps || null
                this.limitGoldValuePerBox = response.data.limitGoldValuePerBox
                this.jenisPinjaman = response.data.jenisPinjaman || null
            })
            .catch(error => this.$helper.parseError(this, error))
        },

        goToDusDetail(dus){
            this.$router.push(`/lelang/persiapan-lelang/${this.id}/dus/${dus.id}`)
        },

        openModalTambahDus(){
            this.newDusType = null
            this.isLoadingDusTypeOptions = true

            this.$axios.get(`lelang-packing/${this.id}/box-types`).then(response => {
                this.dusTypeOptions = response.data
                this.$bvModal.show('modal-tambah-dus')
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isLoadingDusTypeOptions = false
            })
        },

        confirmTambahDus(){
            if (!this.newDusType) return

            this.isCreatingDus = true
            this.$axios.post(`lelang-packing/${this.id}/box`, { boxTypeId: this.newDusType.id }).then(() => {
                this.$bvModal.hide('modal-tambah-dus')
                this.$helper.toastSucc(this, `${this.dusWord} berhasil ditambahkan!`)
                this.getDusList()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isCreatingDus = false
            })
        },

        canTutupDus(dus){
            return this.canManagePacking && this.canKirimDus && dus.isOpen
        },

        canBukaKembaliDus(dus){
            return this.canManagePacking && this.canKirimDus && !dus.isOpen
        },

        canHapusDus(dus){
            return this.canManagePacking && this.canKirimDus && dus.isOpen
        },

        openModalTutupDus(dus){
            if (dus.jumlahBarang == 0) {
                return this.$helper.toastErr(this, `${this.dusWord} masih kosong, tidak bisa ditutup.`)
            }

            this.activeDus = dus
            this.$bvModal.show('modal-confirm-tutup-dus')
        },

        onCloseDus(){
            if (!this.activeDus) return

            this.isClosingDus = true
            this.$axios.post(`lelang-packing/box/${this.activeDus.id}/close`).then(() => {
                this.$bvModal.hide('modal-confirm-tutup-dus')
                this.$helper.toastSucc(this, `${this.dusWord} berhasil ditutup!`)
                this.getDusList()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isClosingDus = false
            })
        },

        openModalBukaKembaliDus(dus){
            this.activeDus = dus
            this.$bvModal.show('modal-confirm-buka-kembali-dus')
        },

        onReopenDus(){
            if (!this.activeDus) return

            this.isReopeningDus = true
            this.$axios.post(`lelang-packing/box/${this.activeDus.id}/reopen`).then(() => {
                this.$bvModal.hide('modal-confirm-buka-kembali-dus')
                this.$helper.toastSucc(this, `${this.dusWord} berhasil dibuka kembali!`)
                this.getDusList()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isReopeningDus = false
            })
        },

        openModalHapusDus(dus){
            this.activeDus = dus
            this.$bvModal.show('modal-confirm-hapus-dus')
        },

        onDeleteDus(){
            if (!this.activeDus) return

            this.isDeletingDus = true
            this.$axios.post(`lelang-packing/delete-box/${this.activeDus.id}`).then(() => {
                this.$bvModal.hide('modal-confirm-hapus-dus')
                this.$helper.toastSucc(this, `${this.dusWord} berhasil dihapus!`)
                this.getDusList()
                this.getPersiapanLelangItems()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isDeletingDus = false
            })
        },

        openModalKirim(){
            if (this.dusList.some(dus => dus.isOpen)) {
                return this.$helper.toastErr(this, `Masih ada ${this.dusWord.toLowerCase()} yang belum ditutup. Tutup semua ${this.dusWord.toLowerCase()} dulu sebelum kirim.`)
            }

            this.isLoadingKirimOptions = true

            this.$axios.get(`lelang-packing/batch/${this.id}/completeness-check`).then(response => {
                if (response.data.id == 0) {
                    this.$helper.toastErr(this, response.data.name)
                    return
                }

                return this.$axios.get(`lelang-packing/batch/${this.id}/delivery-method`).then(response => {
                    this.kirimInfo = response.data
                    this.$bvModal.show('modal-kirim-dus')
                })
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isLoadingKirimOptions = false
            })
        },

        openModalRangkumanDus(){
            this.isLoadingBoxesSummary = true
            this.$axios.get(`lelang-packing/${this.id}/boxes-summary`).then(response => {
                this.boxesSummary = response.data.map(item => ({
                    noDus: this.$helper.dusNumber(item.boxNumber),
                    tipeDus: item.boxType,
                    jumlahBarang: item.itemQuantity,
                    beratKeringEmasAwal: item.totalGoldWeightGadai,
                    beratKeringEmas: item.totalGoldGrossWeight,
                    nilaiPinjamanAwal: item.totalPinjamanPokokAwal,
                }))
                this.$bvModal.show('modal-rangkuman-dus')
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isLoadingBoxesSummary = false
            })
        },

        onKirimSubmitted(){
            this.getDusList()
            this.getShipmentStatus()
        },

        onResetShipment(){
            this.isResettingShipment = true
            this.$axios.post('lelang-packing/shipment/decline/supervisor', { shipmentId: this.id }).then(response => {
                if (response.data.id == 0) return this.$helper.toastErr(this, response.data.name)

                this.$bvModal.hide('modal-confirm-reset-dropoff')
                this.$helper.toastSucc(this, response.data.name)
                this.getShipmentStatus()
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isResettingShipment = false
            })
        },

        printSegelLelang(printWithGold) {
            if (this.dusList.length == 0) {
                return this.$helper.toastErr(this, `Belum ada ${this.dusWord.toLowerCase()}, tidak dapat mencetak segel!`)
            }

            this.isPrintingSegel = true
            this.isPrintingSegelWithGold = printWithGold
            this.segelPathDownload = ""
            this.$bvModal.show('modal-download-segelLelang')

            this.$axios.get('lelang-packing/print-segel-lelang', { params: { batchId: this.id, printWithGold } }).then(response => {
                this.segelPathDownload = `${this.$baseFilePath}${response.data}`
            })
            .catch(error => {
                this.$bvModal.hide('modal-download-segelLelang')
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isPrintingSegel = false)
        },

        printLabelLelang(printWithGold) {
            if (this.dusList.length == 0) {
                return this.$helper.toastErr(this, `Belum ada ${this.dusWord.toLowerCase()}, tidak dapat mencetak label!`)
            }

            this.isPrintingLabel = true
            this.isPrintingLabelWithGold = printWithGold
            this.labelPathDownload = ""
            this.$bvModal.show('modal-download-labelLelang')

            this.$axios.get('lelang-packing/print-label-lelang', { params: { batchId: this.id, printWithGold } }).then(response => {
                this.labelPathDownload = `${this.$baseFilePath}${response.data}`
            })
            .catch(error => {
                this.$bvModal.hide('modal-download-labelLelang')
                this.$helper.parseError(this, error)
            })
            .finally(() => this.isPrintingLabel = false)
        },

        printBarcode(id) {
            this.selectedId = id
            this.$bvModal.show("m-print-barcode")
            this.isLoadingBarcode = true

            this.$axios.get(`gadai/print-barcode/${this.selectedId}`).then(res => {
                this.barcodePath = this.$baseFilePath + res.data.name
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isLoadingBarcode = false)
        }

    },

    created(){
        this.init()
    }
}
</script>

<style scoped>
/* lembar segel lebarnya tetap (ukuran cetak), jadi wrapper yang digeser — scroll di dalam iframe tidak jalan di mobile */
.segel-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.segel-frame {
    display: block;
    width: 100%;
    min-width: 900px;
    border: 0;
}
.dus-card {
    background: #fff;
    border: 1px solid #e2e5e9;
    border-radius: 10px;
    padding: 14px 16px;
}
.dus-card-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}
.print-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #fff;
    border: 1px solid #e2e5e9;
    border-radius: 10px;
    padding: 16px;
}
.print-card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-bottom: 12px;
    border-radius: 10px;
    background: #f0f5fb;
    color: var(--primary);
    font-size: 18px;
}
.print-card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: auto;
    padding-top: 12px;
}
.dropoff-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
    border: 1px solid #e2e5e9;
    border-radius: 10px;
    background: #fff;
}
.dropoff-info-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #f0f5fb;
    color: var(--primary);
    font-size: 18px;
}
.shipment-status-badge {
    font-size: 0.75rem;
    padding: 6px 10px;
}
</style>
